import { writable } from "svelte/store";
import { tweened } from "svelte/motion";
import { quadOut } from "svelte/easing";

export const mode = writable(null);
export const seed = writable(Math.random());
export const noiseFactor = writable(0.5);
export const reliefFactor = writable(0.65);
export const borderFactor = writable(0.05);
export const waveStyle = writable(1); // 1 sine, 2 V, 3 grid, 4 arcs
export const waveOpacity = writable(0.1);
export const waveSpeed = writable(0.25);
export const waveScale = writable(1.0);
export const waveThickness = writable(0.1);
export const vignette = writable(0.7);
export const grain = writable(0.1);

const devicePixelDensity =
  typeof window !== "undefined" ? window.devicePixelRatio || 1 : 1;
export const resolutionScale = writable(Math.min(1, 1.5 / devicePixelDensity));
export const fakeHeightFactor = tweened(1.0, {
  duration: 0,
  easing: quadOut,
});
export const selectedOverlay = writable(null);
export const paletteName = writable("verdant");
export const palette = writable([]);
export const overlays = writable([]);
export const canvasWidth = writable(0);
export const canvasHeight = writable(0);
